import * as React from "react";

const NISDownloadIcon: React.FC = () => {
    return (
     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M13.625 6.125H2.375C1.33936 6.125 0.5 6.96582 0.5 8V10.8125C0.5 11.3302 0.919824 11.75 1.4375 11.75H2.375V14.5625C2.375 15.0802 2.79482 15.5 3.3125 15.5H12.6875C13.2052 15.5 13.625 15.0802 13.625 14.5625V11.75H14.5625C15.0802 11.75 15.5 11.3302 15.5 10.8125V8C15.5 6.96582 14.6592 6.125 13.625 6.125ZM11.75 13.625H4.25V10.8125H11.75V13.625ZM13.1562 9.17188C12.7681 9.17188 12.4531 8.85693 12.4531 8.46875C12.4531 8.07998 12.7681 7.76562 13.1562 7.76562C13.5444 7.76562 13.8594 8.07998 13.8594 8.46875C13.8594 8.8584 13.5459 9.17188 13.1562 9.17188ZM4.25 2.375H10.9736L11.75 3.15166V5.1875H13.625V2.76318C13.625 2.51463 13.5261 2.27627 13.3503 2.10049L12.0247 0.774805C11.8496 0.598877 11.6094 0.5 11.3633 0.5H3.3125C2.79512 0.5 2.375 0.919824 2.375 1.4375V5.1875H4.25V2.375Z" fill="#2B5197"/>
</svg>

    );
};

export default React.memo(NISDownloadIcon);
